import {TYPES} from './requirements-assessment-action-type.constants';
import {TYPES as ACC_TYPES} from '../accreditation-action-type.constants';
import {IDS} from './requirements-assessment-action-id.constants';
import API from '../../../common/http/api.fetch';
import I18N from '../../../common/utils/util.i18n';
import {GRID_FETCH, GRID_FILTER} from '../../../common/grid/grid.constants';
import {responseMessage, success} from '../../../common/utils/util.notifier';
import pick from 'lodash/pick';
import {getDocFileNameFromPath} from "../../../common/utils/util.path";
import * as GRID from "../../../common/grid/grid.constants";

export const fetchSiteLocationDetails = (siteLocationUuid) => {
    return dispatch => {
        return API.fetch({
            url: `/location/sitelocation/${siteLocationUuid}`,
            method: 'GET',
            params: {}
        }).then(response => {
            const siteLocation = response.data[0][0];
            dispatch({
                type: TYPES.FETCH_SITE_LOCATION_DETAILS,
                id: IDS.rcoRequirementsAssessment,
                locationName: siteLocation.name,
                locationUuid: siteLocation.subject_uuid,
                fiscalYearStart: parseInt(siteLocation.fiscal_year_start) - 1,
                autocompleteAuditors: response.data[1].map(item => ({ ...item,
                    assignee_uuid: item.subject_uuid
                })),
            })
        })
    }
}

// export const fetchAuditTasks = (ase_id, slo_uuid, year) => {
//     return dispatch => {
//         return API.fetch({
//             url: '/rco/list-tasks',
//             method: 'GET',
//             params: {
//                 ase_id,
//                 slo_uuid,
//                 year_start: year,
//                 year_end: year,
//                 task_type: 'utrcau',
//                 limit: -1,
//             }
//         }).then(response => {
//             return response.data.items;
//         })
//     }
// }

export const resetSelectedAuditTask = () => {
    return dispatch => {
        dispatch({
            type: TYPES.RESET_SELECTED_AUDIT_TASK,
        })
    }
}

export const fetchRequirementAuditorStatuses = (ase_id, slo_uuid, fiscal_year, userUuid, ard_id = undefined) => {
    return dispatch => {
        return API.fetch({
            url: '/rco/list-requirement-auditor-statuses',
            method: 'GET',
            params: {
                ase_id,
                slo_uuid,
                fiscal_year,
                ard_id,
            }
        }).then(response => {
            dispatch({
                type: TYPES.FETCH_AUDITOR_STATUSES,
                userUuid,
                auditorStatuses: response.data.map(item => {
                    const statusName = I18N.translate(
                        `COMMON.STATUS.${item.requirement_assessment_status?.toUpperCase()}`,
                        item.requirement_assessment_status
                    );
                    return {
                        ...item,
                        statusName,
                        assignee: `${item.assignee} (${item.type_name})`,
                    }
                }),
            });
        })
    }
}

// export const fetchEvidenceAuditorStatuses = (ase_id, slo_uuid, year, ard_id) => {
//     return dispatch => {
//         return API.fetch({
//             url: '/rco/list-requirement-evidence-group-auditors',
//             method: 'GET',
//             params: {
//                 ase_id,
//                 slo_uuid,
//                 year,
//                 ard_id,
//             }
//         }).then(response => {
//             dispatch({
//                 type: GRID_FETCH,
//                 id: IDS.rcoRequirementsAssessment,
//                 path: IDS.accDocAuditorsGrid,
//                 items: response.data.map(item => ({
//                     ...item,
//                     statusName: I18N.translate(`COMMON.STATUS.${item.requirement_evidence_group_assessment.toUpperCase()}`),
//                     assignee: `${item.assignee} (${item.type_name})`,
//                     lastChange: item.doc_review_date,
//                     reviewComment: item.doc_review_comment,
//                 }))
//             });
//         })
//     }
// }

export const fetchEvidenceGroupHistory = (params) => {
    return dispatch => {
        if(!params.ase_id || !params.slo_uuid || !params.year || !params.ard_id)
            return
        return API.fetch({
            url: '/rco/list-evidence-group-history',
            method: 'GET',
            params,
        }).then(({data}) => {
            dispatch({
                type: GRID_FETCH,
                id: IDS.rcoRequirementsAssessment,
                path: IDS.rcoEvidenceGroupHistoryGrid,
                itemsCount: data.items_count,
                items: data.items.map(item => {

                    let eventType = '';
                    switch(item.task_type_code) {
                        case 'utrcer' : eventType = 'Requested Review from'; break;
                        case 'utrcdr' : eventType = 'Requested Revision from'; break;
                        case 'updated': eventType = 'Updated Document'; break;
                        case 'removed': eventType = 'Removed Document'; break;
                        case 'assessed': eventType = 'Assessed Document'; break;
                        default: eventType = '';
                    }
                    const [date, time] = item.created.split(' ');
                    return {
                        ...item,
                        eventType,
                        statusName: item.status_name === 'inv' ? 'Canceled' : item.status_name,
                        date,
                        time,
                    }
                }),
            });
        })
    }
}

export const fetchEvidenceGroupsProgressGrid = (filter) => {
    return dispatch => {
        if(!filter.requirementId || !filter.siteLocationUuid)
            return
        return API.fetch({
            url: '/rco/list-evidence-groups-progress',
            method: 'GET',
            params: filter,
        }).then( ({data}) => {
            Array.isArray(data.items) && data.items.forEach(requiredDocument => {
                requiredDocument.sampleDocFilename = getDocFileNameFromPath(requiredDocument.sample_doc_path);
                // requiredDocument.reviewers.forEach((reviewer, index) => {
                //     reviewer.status_name = I18N.translate(`COMMON.STATUS.${reviewer.status_code.toUpperCase()}`);
                //     // requiredDocument[`reviewer${index + 1}`] = reviewer.status_name; // create grid column for each reviewer
                // })
            })
            return dispatch({
                type: GRID.GRID_FETCH,
                id: IDS.rcoRequirementsAssessment,
                path: IDS.rcoEvidenceGroupsProgressGrid,
                ...data,
                items: data.items.map(item => {
                    item.doc_type_name = I18N.translate(`COMMON.DOCUMENT.CODE.${item.doc_type_code.toUpperCase()}`, item.doc_type_name);
                    const evidenceType = item.vdo_uuid ? item.doc_type_name : I18N.translate('COMMON.FIELD.DOCUMENTS');
                    return {
                        ...item,
                        is_enabled: !!item.is_enabled,
                        status_name:
                            ! item.is_enabled ? 'Not Applicable'
                            : item.doc_revision_task_status_code === 'cpl' ? 'Waiting for approval'
                            : item.doc_revision_task_status_code === 'pen' ? 'Returned for revision'
                            : item.review_task_status_code === 'pen' ? 'Waiting for review'
                            : item.status_code === 'nap'  ? 'Returned for revision'
                            : item.status_code === 'pen'  ? 'Waiting for approval'
                            : I18N.translate(`COMMON.STATUS.${item.status_code?.toUpperCase()}`, item.status_name),
                        class:
                            !item.is_enabled ? 'rcoDocumentNotApplicable'
                            : item.status_code === 'app' ? 'rcoDocumentApproved'
                            : item.doc_revision_task_status_code === 'cpl' ? 'rcoDocumentRevised'
                            : item.doc_revision_task_status_code === 'pen' ? 'rcoDocumentReturned'
                            : item.review_task_status_code === 'cpl' ? 'rcoDocumentRevised'
                            : item.review_task_status_code === 'pen' ? undefined
                            : item.status_code === 'nap'  ? 'rcoDocumentReturned'
                            : item.status_code === 'pen'  ? undefined
                            : undefined, // white
                        levelAndType: `${item.level} ${evidenceType}`,
                        filename: getDocFileNameFromPath(item.doc_url),
                    }
                })
            })
        }, error => {
            responseMessage(error);
        });
    }
}

export const deactivateEvidenceForSite = (evg_id, slo_uuid, fre_id = undefined, successMessage = 'COMMON.SERVER_RESPONSE.ITEM_DELETED') => {
    return dispatch => {
        return API.fetch({
            url: '/rco/deactivate-evidence-group-for-site',
            method: 'POST',
            data: {
                evg_id,
                slo_uuid,
                fre_id,
            }
        }).then(response => {
            success(successMessage);
        }, error => {
            responseMessage(error);
        });
    };
}

export const reactivateEvidenceForSite = (evg_id, slo_uuid, fre_id = undefined) => {
    return dispatch => {
        return API.fetch({
            url: '/rco/reactivate-evidence-group-for-site',
            method: 'POST',
            data: {
                evg_id,
                slo_uuid,
                fre_id,
            }
        }).then(response => {
            success('COMMON.SERVER_RESPONSE.ITEM_ENABLED');
        }, error => {
            responseMessage(error);
        });
    };

}

export const setLocationFilter = (slo_uuid) => {
    return dispatch => {
        return dispatch({
            type:   GRID_FILTER,
            id:     IDS.rcoRequirementsAssessment,
            path:   IDS.documentAddGrid,
            filter: { slo_uuid }
        })
    }
}

export const setDocumentAssessment = (data) => {
    return dispatch => {
        return API.fetch({
            url: `/rco/set-document-assessment`,
            method: 'POST',
            data,
        }).then(response => {
            success(
                data.revision_assignee
                ? 'COMMON.SERVER_RESPONSE.ITEM_ASSIGNED'
                : 'COMMON.SERVER_RESPONSE.ITEM_UPDATED'
            );
        },error => {
            responseMessage(error)
        });
    };
}

export const addImprovementAction = (data) => {
    return dispatch => {
        return API.fetch({
            url: '/rco/add-improvement-action',
            method: 'POST',
            data,
        }).then(response => {
            success('COMMON.SERVER_RESPONSE.ITEM_ADDED');
        },error => {
            responseMessage(error)
        });
    };
}

export const fetchAssessmentRequirementsTreeProgress = (scheme_code, slo_uuid, fiscal_year) => {
    return dispatch => {
        return API.fetch({
            url: '/rco/framework-requirements-tree-progress',
            params: {slo_uuid, fiscal_year, scheme_code},
            method: 'GET'
        }).then( response => {
            const sectionsList = index(response.data);
            sectionsList.forEach(item => {
                item.statusName = I18N.translate(
                    `ACCREDITATION.REQUIREMENTS.STATUS.${item.status_code?.toUpperCase()}`,
                    item.status_name
                );
            })
            dispatch({
                type: ACC_TYPES.FETCH_SECTIONS_TREE_PROGRESS,
                id: IDS.rcoRequirementsAssessment,
                data: response.data
            });
            return response.data;
        }, error => {
            responseMessage(error);
        });
    }
}

const index = (children, list = []) => {
    children && children.forEach(item => {
        if(item) {
            list[parseInt(item.id)] = item;
            index(item.children, list);
        }
    })
    return list;
};
